import type { TimelineEventView } from '@solar/contracts';

import styles from './PortalComponents.module.css';

function formatWhen(value: string): string {
  return new Date(value).toLocaleString();
}

export function Timeline({
  events,
}: {
  events: readonly TimelineEventView[];
}): React.JSX.Element | null {
  if (events.length === 0) {
    return null;
  }

  return (
    <ol className={styles.timeline} aria-label="Timeline">
      {events.map((event) => (
        <li className={styles.timelineItem} key={event.id}>
          <span className={styles.timelineMarker} aria-hidden="true" />
          <div className={styles.timelineContent}>
            <p className={styles.timelineMeta}>
              {formatWhen(event.occurredAt)} · {event.category.replace(/_/g, ' ')}
            </p>
            <p className={styles.timelineLabel}>{event.label}</p>
            {event.description !== null && (
              <p className={styles.timelineDescription}>{event.description}</p>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
